export class AccountBalanceDto {
    grossARBalance : number = 0;
    openCreditBalance: number = 0;
    openCashBalance: number = 0;
    netBalance: number = 0;
}